import React from 'react';

export const TITLE_FILMS = [
  {
    textSize: '3.375rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Reel</span>,
  },
];

export const REEL_FILMS = [
  {
    textSize: '1rem',
    marginBottom: '0px',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        *Todo el material presentado en este reel de Productor forma parte de la
        trayectoria profesional de Jonathan Bouzali como Productor y Fundador de
        KUTER FILMS. Cada pieza corresponde a proyectos en los que ha
        participado directamente en su rol de Productor.
      </span>
    ),
  },
];
